import styles from "./styles.module.scss";
import Help_1 from "../../assets/home/help_1.png";
import Help_2 from "../../assets/home/help_2.png";
import Help_3 from "../../assets/home/help_3.png";
import { Link } from "react-router-dom";

const solutionCards = [
  {
    eyebrow: "For individual learners",
    title: "Train GRC Academy",
    description:
      "Access expert tutorials on important cloud auditing topics and develop skills through interactive labs at the Train GRC Academy.",
    cta: "Sign up now",
    href: "/signup",
    image: Help_1,
    internal: true,
  },
  {
    eyebrow: "For teams and programs",
    title: "Train GRC Studio",
    description:
      "We can work with your organization to develop custom training based on your technology providers.",
    cta: "Schedule a meeting",
    href: "https://calendly.com/traingrc/custom-training-services",
    image: Help_2,
  },
  {
    eyebrow: "For complex challenges",
    title: "Advisory Services",
    description:
      "Our consultants can help your organization with audit support services, including cohort-based coaching.",
    cta: "Schedule a meeting",
    href: "https://calendly.com/traingrc/initial-advisory-requests",
    image: Help_3,
  },
];

const CardBlock = () => {
  return (
    <section
      className={styles.pathsSection}
      id="solution-paths"
      aria-labelledby="paths-heading"
    >
      <div className={styles.pathsInner}>
        <div className={styles.sectionHeadingDark}>
          <p className={styles.eyebrow}>One mission, three ways to help</p>
          <h2 id="paths-heading">Choose the support that matches the work.</h2>
          <p>
            Learn independently, equip your organization, or bring experienced
            practitioners into the challenge with you.
          </p>
        </div>

        <div className={styles.solutionGrid}>
          {solutionCards.map((card) => {
            const actionContent = (
              <>
                {card.cta}
                <span aria-hidden="true">→</span>
              </>
            );

            return (
              <article className={styles.solutionCard} key={card.title}>
                <div className={styles.solutionIcon} aria-hidden="true">
                  <img src={card.image} alt="" width="112" height="112" />
                </div>
                <p className={styles.cardEyebrow}>{card.eyebrow}</p>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                {card.internal ? (
                  <Link to={card.href}>{actionContent}</Link>
                ) : (
                  <a href={card.href}>{actionContent}</a>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CardBlock;
